import { FormattedMessage } from 'react-intl';

import { Schema } from 'src/utils/form';

export default Schema.object({
  nome: Schema.string().label(<FormattedMessage id="nome" />),
  idIntegracao: Schema.string().label(<FormattedMessage id="idIntegracao" />),
  responsavel: Schema.string().label(<FormattedMessage id="responsavel" />),
  status: Schema.string().label(<FormattedMessage id="status" />),
  statusPerdaOperacionalList: Schema.string().label(
    <FormattedMessage id="status" />
  ),
  areasGeradoras: Schema.string().label(
    <FormattedMessage id="areasGeradoras" />
  ),
  areasGeradorasSubordinadas: Schema.boolean(),
  responsaveisAnalise: Schema.string().label(
    <FormattedMessage id="responsaveisPelaAnalise" />
  ),
});
